import { ChatPanel } from '@/components/chat/ChatPanel';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useGlobalStore } from '@/store';

export const ChatWidget = () => {
    const chatAssistantEnabled = useFeatureFlag('chatAssistantEnabled');
    const isLoggedIn = useGlobalStore((state) => state.isLoggedIn);
    const isChatOpen = useGlobalStore((state) => state.isChatOpen);
    const setIsChatOpen = useGlobalStore((state) => state.setIsChatOpen);

    if (!chatAssistantEnabled || !isLoggedIn) {
        return false;
    }

    return <ChatPanel isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />;
};
